import { useRoutes } from "react-router-dom";
import routes from "./routes";
import globalContext from "./Context/GlobalContext";
import Header from "./components/modules/Header/Header";
import { useEffect, useState } from "react";
import axios from "axios";
import { UAParser } from "ua-parser-js";
import { useCookies } from "react-cookie";
import md5 from "md5";
import { Buffer } from "buffer";

/**
 * The main application component that sets up routing, context, and API interactions.
 *
 * @component
 * @returns {JSX.Element} The rendered App component.
 */

function App() {
  const BASE_URL = process.env.REACT_APP_TRACKER_API_ADDRESS;
  const [cookies, setCookies, removeCookies] = useCookies();
  const router = useRoutes(routes);
  const [isHeaderShown, setIsHeaderShown] = useState(true);
  const [piecesIndexInMob, setPiecesIndexInMob] = useState(0);

  const [agent, setAgent] = useState(null);

  // Effect to parse user agent information
  useEffect(() => {
    let parser = new UAParser(navigator.userAgent);
    let parserResults = parser.getResult();
    setAgent(parserResults);
  }, []);

  // Effect to handle API calls based on pathname
  useEffect(() => {
    let path = window.location.pathname.substring(1);
    let timeStamp = Date.now() + 180000;
    let payload = {
      rf: `${path}`,
      exp: `${timeStamp}`,
    };
    let objJsonStr = JSON.stringify(payload);
    let payloadBased64 = Buffer.from(objJsonStr).toString("base64");
    let hashedMd5Path = md5(path);
    let token = `${payloadBased64}.${hashedMd5Path}`;
    if (window.location.pathname) {
      const config = {
        headers: {
          client: "web",
          "x-token": `${token.replaceAll("=", "")}`,
        },
      };
      const requestBody = {};
      requestBody.path = path.toString();
      requestBody.ty = process.env.REACT_APP_NAME.toString();
      requestBody.ver = process.env.REACT_APP_VERSION.toString();
      axios
        .post(`${BASE_URL}/web`, requestBody, config)
        .then((res) => {})
        .catch((err) => {});
    }
  }, [window.location.pathname]);

  // Effect to send device information if not already sent
  useEffect(() => {
    if (cookies?.DS !== "true") {
      if (agent) {
        const config = {
          headers: {
            client: "web",
          },
        };

        const requestBody = {};
        if (agent?.cpu?.architecture) {
          requestBody.cpu = agent?.cpu?.architecture.toString();
        }
        if (agent?.browser?.name) {
          requestBody.browser = agent?.browser?.name.toString();
        }
        if (agent?.device?.model) {
          requestBody.model = agent?.device?.model.toString();
        }
        if (agent?.device?.type) {
          requestBody.type = agent?.device?.type.toString();
        }
        if (agent?.os?.name) {
          requestBody.os = agent?.os?.name.toString();
        }

        requestBody.resolution = `${
          window.screen.width * window.devicePixelRatio
        }x${window.screen.height * window.devicePixelRatio}`;
        requestBody.ws = window.innerWidth.toString();
        requestBody.hs = window.innerHeight.toString();
        requestBody.ty = process.env.REACT_APP_NAME.toString();
        requestBody.ver = process.env.REACT_APP_VERSION.toString();

        axios
          .post(`${BASE_URL}/dev`, requestBody, config)
          .then((res) => {
            if (res?.data === "OK") {
              setCookies("DS", "true", {
                path: "/",
                secure: true,
              });
            }
          })
          .catch((err) => {});
      }
    }
  }, [agent]);

  return (
    <>
      <globalContext.Provider
        value={{
          isHeaderShown,
          setIsHeaderShown,
          piecesIndexInMob,
          setPiecesIndexInMob,
        }}
      >
        {window.location.pathname !== "/payment" && <Header />}
        {router}
      </globalContext.Provider>
    </>
  );
}

export default App;
